<template>
  <div class="PastOpportunities" v-if="mergeData">
    <div class="container">
      <h3>Bu fırsatı kaçırmış olabilirsin ama yüzlerce fırsat seni bekliyor!</h3>
      <div class="product-list">
        <div v-if="isMobileDeviceOrScreen()">
          <pastOpportunitiesProductSummaryBox
            v-for="(items, index) in mergeData"
            :key="index" :data="items"
            :campaignStatus="false"
            class="product"
            :data-hbus="handleViewEventData(mergeData, items, index)"
            :index="index"
            :onClick="handleOnClick"
          />
        </div>
        <div v-else>
          <Slick
            class="carousel"
            :options="{
              swipe: true,
              swipeToSlide: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
              arrows:true,
              prevArrow: `<button type='button' class='slick-prev'></button>`,
              nextArrow: `<button type='button' class='slick-next'></button>`,
              pauseOnFocus: true,
              autoplay: false,
              lazyLoad: false,
            }"
            @afterChange="handleAfterChange">
              <div
                v-for="(items, index) in mergeData"
                :key="index"
                class="item">
                <span class="label">
                  <pastOpportunitiesProductSummaryBox
                    :data="items"
                    :campaignStatus="false"
                    class="product"
                    :data-hbus="handleViewEventData(mergeData, items, index)"
                    :index="index"
                    :onClick="handleOnClick"
                  />
                </span>
              </div>
          </Slick>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick';

import pastOpportunitiesProductSummaryBox from "../../view/productSummaryBoxes/pastOpportunitiesProductSummaryBox/pastOpportunitiesProductSummaryBox";

import { isMobileDeviceOrScreen } from "../../common/agent/agentUtils.js";
import { SLOT_NAMES } from '../../analytics/davinci/constants';

export default {
  name: "PastOpportunities",
  props: {
    product: Array,
    onClick: Function,
    viewEventData: Function
  },
  components: {
    Slick,
    pastOpportunitiesProductSummaryBox
  },
  data() {
    return {
      navigationLeftLabel: '<div class="navigationLeftLabel"></div>',
      navigationRightLabel: '<div class="navigationRightLabel"></div>',
      slotName: SLOT_NAMES.MISSED_CAMPAIGN_SLOTS
    };
  },
  computed: {
    mergeData() {
      let grouped = {};

      for (let obj of this.product) {
        for (let [key, val] of Object.entries(obj)) {
          grouped[key] = (grouped[key] || []).concat(val);
        }
      }
      return grouped.campains;
    }
  },
  methods: {
    isMobileDeviceOrScreen,
    handleAfterChange(event, slick, currentSlide) {
      window.dispatchEvent(new CustomEvent('scroll'))
    },

    handleOnClick: function (slot, index) {
      let data = this.mergeData;
      this.onClick(data, slot, this.slotName, index)
    },

    handleViewEventData: function (item, slot, index) {
      return this.viewEventData(item, slot, this.slotName, index)
    },
  },
};
</script>

<style src="./PastOpportunities.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/partials/PastOpportunities/PastOpportunities.vue